import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { Page } from 'modules/layout/components/Page';
import { Placeholder } from 'modules/common/components/Placeholder';
import { isSSG } from 'modules/common/utils/isSSG';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';
import { useRedirectForSmallDevices } from 'hooks/useRedirectForSmallDevices';

const StatisticsPage = loadable(
  async () => {
    const module = await import('./StatisticsPage');

    return module.StatisticsPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const StatisticsPagePlaceholder = loadable(
  async () => {
    const module = await import('./components/StatisticsPlaceholder');

    return module.StatisticsPlaceholder;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const StatisticsPageContainer = () => {
  const { isLoggedIn, isLoggingIn } = useAuth();
  const { isFinance, permissionsInitialized } = useAccount();
  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  useRedirectForSmallDevices();

  const {
    initialLoading: accountStatusInitalLoading,
    isEnterprise,
    isPremium,
  } = useAccountStatus();

  const loading =
    isLoggingIn ||
    accountStatusInitalLoading ||
    isPartnerStatusLoading ||
    (isLoggedIn && !permissionsInitialized);

  const shouldShowStatisticsPage = isPremium || isPartnerClient || isEnterprise;

  const shouldShowPlaceholder = isSSG() || !shouldShowStatisticsPage;

  return (
    <Page>
      <Placeholder hasPlaceholder={loading} placeholder={<OverlaySpinner />}>
        <Placeholder
          hasPlaceholder={shouldShowPlaceholder && !isFinance}
          placeholder={<StatisticsPagePlaceholder />}
        >
          <GuardAccountPermission
            permission={AccountPermission.UsageData}
            shouldRedirect
            shouldHideAlert
          >
            <StatisticsPage />
          </GuardAccountPermission>
        </Placeholder>
      </Placeholder>
    </Page>
  );
};
